<div class="mt-table-wrapper">
  <div class="mt-pg-hdr-sec with-tbl" [ngClass]="class">
    <div class="mt-filter-box">
      @if (tableHeader) {
        <span class="table-header">{{
          tableHeader.title
        }}</span>
      }
      @if (tableHeader && tableHeader.subTitle) {
        <img
          class="imageIcon"
          src="../../../../assets/img/icons/ic-user.svg"
          alt=""
          />
        <span class="subTitle">{{ count }} {{ tableHeader.subTitle }}</span>
      }
      <ng-content select="[tableHeader]"></ng-content>
      <span class="sp"></span>
      @if (tableFeatures.download) {
        <mt-btn
          class="outline"
          [disabled]="count < 1 || loading || disablebtn"
          (onAction)="downloadRecords()"
          >
          <span class="ic_download mr-5"></span>
          Download {{ count }}
        </mt-btn>
      }
      @if (tableFeatures.search) {
        <mt-search
          class="small search"
          label="Search here..."
          placeholder="Search here..."
          [model]="searchStr"
          (onSearch)="searchRecords($event)"
          >
        </mt-search>
      }
      @if (tableButtons && tableButtons.length) {
        @for (button of tableButtons; track button) {
          <mt-btn
            [class]="button.class"
            (onAction)="onButtonAction(button.value)"
            [disabled]="$safeNavigationMigration(button?.disable)"
            >
            <span [class]="button.icon" class="mr-5 small"></span>
            {{ button.name }}
          </mt-btn>
        }
      }
    </div>
  </div>

  @if (tableFeatures.selectable) {
    <div class="mt-select-all-cont">
      @if (selectedDues && selectedDues.length > 0) {
        <p class="mr-10">
          {{ selectedDues.length }} / {{ count }}
          {{ selectedDues.length > 1 ? "Rows are" : "Row" }}
          selected
        </p>
        <!-- <mt-btn (onAction)="selectAllRecords()" class="link">
        {{ pageObj.selectAllDues ? 'Clear all' : 'Select all accounts' }}
      </mt-btn> -->
    }
    <span class="sp"></span>
    <!-- TODO: Do something... -->
  </div>
}
@if (headers && headers.length) {
  @if (!features.noScroll) {
    <div
      class="mt-table-body"
      [ngClass]="count < 1 ? 'no-scroll' : ''"
      >
      <mat-table
        #table
        [dataSource]="rowsData"
        matSort
        (matSortChange)="onSorting($event)"
        >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select" sticky>
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              color="primary"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()"
              >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? rowToggle(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
              >
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        @for (header of headers; track header) {
          <ng-container
            [cdkColumnDef]="header.name"
            >
            <!-- Headers -->
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>
              {{ header.name }}
            </mat-header-cell>
            <!-- table cell -->
            @if (!tableFeatures.isPipeSaperate) {
              <mat-cell
                *cdkCellDef="let row"
                (click)="onColClick(header.prop, row)"
                >
                <span class="cell-data-width" [ngClass]="header.cellClass"
                  >{{
                  header.type == "actions"
                  ? header.prop
                  : tableFeatures.rawData
                  ? (row[header.prop] | formatter : header.pipe)
                  : (row
                  | dataFormatter : row : header.prop
                  | formatter : header.pipe)
                  }}
                </span>
              </mat-cell>
            }
            <!-- if needs to show values are saperated with | -->
            @if (tableFeatures.isPipeSaperate) {
              <mat-cell *cdkCellDef="let row">
                <span class="cell-data-width" [ngClass]="header.cellClass">
                  @if (isString(row[header.prop])) {
                    <a
                      class="filter-btn"
                      (click)="onColClick(header.prop, row, 0)"
                      >
                      {{
                      row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe
                      }}
                    </a>
                  }
                  @if (!isString(row[header.prop])) {
                    @if (row[header.prop] && row[header.prop].length > 0) {
                      @for (val of row[header.prop]; track val; let i = $index) {
                        <a (click)="onColClick(header.prop, row, i)">
                          {{ val | formatter : header.pipe }}
                        </a>
                        @if (i == 0) {
                          |
                        }
                      }
                    }
                  }
                  @if (header.values) {
                    <span class="cell-data-width" [ngClass]="header.cellClass">
                      @for (btn of header.values; track btn) {
                        <mt-btn
                          (onAction)="onRowButtonAction(btn.value, row)"
                          [class]="btn.class"
                          [disabled]="loading"
                          >
                          <span [class]="btn.icon"></span
                          ></mt-btn>
                        }
                      </span>
                    }
                  </span>
                </mat-cell>
              }
            </ng-container>
          }
          <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns; let rowIndex = index"
            (click)="onClick(row)"
            [ngClass]="getRowClass(row)"
            >
          </mat-row>
        </mat-table>
        @if (count < 1) {
          <h4 class="mt-no-rows-found">{{ notFoundMsg }}</h4>
        }
      </div>
    }
    @if (features.noScroll) {
      <div
        class="mt-table-body"
        [ngClass]="count < 1 ? '' : ''"
        >
        <mat-table
          #table
          [dataSource]="rowsData"
          matSort
          (matSortChange)="onSorting($event)"
          >
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select" sticky>
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                color="primary"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
                >
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <mat-checkbox
                color="primary"
                (click)="$event.stopPropagation()"
                (change)="$event ? rowToggle(row) : null"
                [checked]="selection.isSelected(row)"
                [aria-label]="checkboxLabel(row)"
                >
              </mat-checkbox>
            </mat-cell>
          </ng-container>
          @for (header of headers; track header) {
            <ng-container
              [cdkColumnDef]="header.name"
              >
              <!-- Headers -->
              <mat-header-cell *cdkHeaderCellDef mat-sort-header>
                {{ header.name }}
              </mat-header-cell>
              <!-- table cell -->
              @if (!tableFeatures.isPipeSaperate) {
                <mat-cell
                  *cdkCellDef="let row"
                  (click)="onColClick(header.prop, row)"
                  >
                  @if (header.name != 'Action') {
                    <span class="cell-data-width" [ngClass]="header.cellClass"
                      >{{
                      header.type == "actions"
                      ? header.prop
                      : tableFeatures.rawData
                      ? (row[header.prop] | formatter : header.pipe)
                      : (row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe)
                      }}
                    </span>
                  }
                  <!-- <ng-container *ngIf="header.prop == '' ">
                  <span class="">-</span>
                </ng-container> -->
                @if (header.name == 'Status') {
                  <span class="statusIcon" [ngClass]="header.cellClass">
                    <!-- {{ row | dataFormatter: row:header.prop | formatter: header.pipe }} -->
                    @if (
                      (row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe) == '-' ||
                      (row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe) == 'due'
                      ) {
                      <img
                        src="../../../../assets/img/icons/paymentDueStatus.svg"
                        alt="paymentDueStatus"
                        />
                    }
                    @if (
                      (row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe) == 'paid'
                      ) {
                      <img
                        src="../../../../assets/img/icons/paymentDoneStatus.svg"
                        alt="paymentDoneStatus"
                        />
                    }
                    @if (
                      (row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe) == 'partial_paid'
                      ) {
                      <img
                        src="../../../../assets/img/icons/paymentPendingStatus.svg"
                        alt="paymentPendingStatus"
                        />
                    }
                    @if (
                      (row
                      | dataFormatter : row : header.prop
                      | formatter : header.pipe) == 'failed'
                      ) {
                      <img
                        src="../../../../assets/img/icons/paymentFailedStatus.svg"
                        alt="paymentFailedStatus"
                        />
                    }
                  </span>
                }
                @if (header.name == 'Action') {
                  <mt-btn class="statusActionBtn" (onAction)="openDialog(row)"
                    ><img
                    src="../../../../assets/img/icons/statusActionIcon.svg"
                    alt="statusActionIcon"
                  /></mt-btn>
                }
              </mat-cell>
              <!-- <ng-container *ngIf="header.name == 'Action'">
              <mat-cell  *cdkCellDef="let row">
                <button mat-menu-item (click)="openDialog(row)">Edit</button>
              </mat-cell>
            </ng-container> -->
          }
          <ng-container> </ng-container>
          <!-- if needs to show values are saperated with | -->
          @if (tableFeatures.isPipeSaperate) {
            <mat-cell *cdkCellDef="let row">
              <span class="cell-data-width" [ngClass]="header.cellClass">
                @if (isString(row[header.prop])) {
                  <a
                    class="filter-btn"
                    (click)="onColClick(header.prop, row, 0)"
                    >
                    {{
                    row
                    | dataFormatter : row : header.prop
                    | formatter : header.pipe
                    }}
                  </a>
                }
                @if (!isString(row[header.prop])) {
                  @if (row[header.prop] && row[header.prop].length > 0) {
                    @for (val of row[header.prop]; track val; let i = $index) {
                      <a (click)="onColClick(header.prop, row, i)">
                        {{ val | formatter : header.pipe }}
                      </a>
                      @if (i == 0) {
                        |
                      }
                    }
                  }
                }
                @if (header.values) {
                  <span class="cell-data-width" [ngClass]="header.cellClass">
                    @for (btn of header.values; track btn) {
                      <mt-btn
                        (onAction)="onRowButtonAction(btn.value, row)"
                        [class]="btn.class"
                        [disabled]="loading"
                        >
                        <span [class]="btn.icon"></span
                        ></mt-btn>
                      }
                    </span>
                  }
                </span>
              </mat-cell>
            }
          </ng-container>
        }
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns; let rowIndex = index"
          (click)="onClick(row)"
          [ngClass]="getRowClass(row)"
          >
        </mat-row>
      </mat-table>
      @if (count < 1) {
        <h4 class="mt-no-rows-found">{{ notFoundMsg }}</h4>
      }
    </div>
  }
  @if (count > 10) {
    @if (!tableFeatures.extPage) {
      <mat-paginator
        [length]="count ? count : rows.length"
        [pageSizeOptions]="pageLengths"
        [pageSize]="sendLimit ? limit : postObj.limit"
        showFirstLastButtons
      ></mat-paginator>
    }
    @if (tableFeatures.extPage) {
      <paginator
        [counts]="count"
        [limit]="postObj.limit"
        [offset]="postObj.offset"
        (onPage)="onPaginate($event)"
        >
      </paginator>
    }
  }
}
</div>
